<template>
  <div>Admin manage user</div>
</template>

<script>
export default {
  name: "AdminManageUser",
};
</script>
